export default __webpack_public_path__ + "static/media/work_ec-likes.ff2f40e7.jpg";